var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
var OutsourceBackCService = /** @class */ (function () {
    function OutsourceBackCService() {
    }
    /**
     * 归C案件池列表
     */
    OutsourceBackCService.prototype.getCaseBackCPoolPageList = function (params, page, sort) {
        return this.netService.send({
            server: domainService.outsourceBackCManageController.getCaseSettlePoolPageList,
            data: {
                outBatch: params.outBatch,
                caseNumber: params.caseNumber,
                personalName: params.personalName,
                mobileNo: params.mobileNo,
                idCard: params.idCard,
                area: params.area,
                customerCategory: params.customerCategory,
                outAmountMax: params.outAmount ? params.outAmount.max : '',
                outAmountMin: params.outAmount ? params.outAmount.min : '',
                overduePeriod: params.overduePeriod,
                overdueDaysMax: params.overdueDays ? params.overdueDays.max : '',
                overdueDaysMin: params.overdueDays ? params.overdueDays.min : '',
                currentCollector: params.currentCollector,
                followupBack: params.followupBack,
                turnSource: params.turnSource,
                productCategory: params.productCategory,
                productName: params.productName,
                followInTimeMax: FilterService.dateRanageFormat(params.followInTime).end,
                followInTimeMin: FilterService.dateRanageFormat(params.followInTime).start,
                outId: params.outId,
                collectionStatus: 'OUTER_BANKC',
                labelName: params.labelName,
                caseMoneyMin: params.caseMoney ? params.caseMoney.min : '',
                caseMoneyMax: params.caseMoney ? params.caseMoney.max : '',
            },
            page: page,
            sort: sort,
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceBackCService.prototype, "netService", void 0);
    return OutsourceBackCService;
}());
export { OutsourceBackCService };
